import React, { useState } from 'react';
import { expensTableSTyle as styles } from '../ExpenseStatement/ExpenseStatementTable/expenseTableStyle.js';
const CashflowStatementTable = ({ item = [],productName }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOutFlowExpanded, setIsOutFlowExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const toggleOutFlowExpansion = () => {
    setIsOutFlowExpanded(!isOutFlowExpanded);
  };

  const formatCurrency = (amount) => {
    if (amount === 0) return '₹0';
    if (amount < 0) return `-₹${Math.abs(amount).toLocaleString('en-IN')}`;
    return `₹${amount.toLocaleString('en-IN')}`;
  };

  const formatMonth = (dateString) => {
    const date = new Date(dateString);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthNames[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
  };

  

  const calculateThirdPartyTotal = (thirdPartyData) => {
    return Object.values(thirdPartyData).reduce((sum, value) => sum + value, 0);
  };

  return (
    <div style={styles.container}>
      <div style={styles.expenseTableContainer}>
        {/* <h1 style={styles.expenseTableTitle}>Expense Table</h1> */}
                  <div style={{width:"100%",backgroundColor:"rgb(38, 49, 69)",padding:"20px",color:"white",textAlign:"center",borderTopLeftRadius:"16px",fontSize:"16px",borderTopRightRadius:"16px"}}>{productName ?? ""}</div>
        <div style={styles.tableContainer}>

          {/* Fixed Left Column */}
          <div style={styles.leftColumn}>
            <div style={{...styles.headerCell, ...styles.leftHeader}}>Cash Flow Statement</div>
            
            <div style={styles.row}>
              <div style={styles.leftCell}>Cash at begining of the month</div>
            </div>
            
            <div 
              style={{...styles.row, ...styles.expandableRow}} 
              onClick={toggleExpansion}
            >
              <div style={styles.leftCell}>Cash Inflow from</div>
              <div style={{...styles.expandIcon,transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                <div style={isExpanded ? styles.arrowUp : styles.arrowDown}></div>
              </div>
            </div>
            
            <div style={{...styles.subRows,...styles.subCont, maxHeight: isExpanded ? '270px' : '0',}}>
              <div style={styles.subRow}>Processing Fees</div>
              <div style={styles.subRow}>Interest</div>
              <div style={styles.subRow}>1st trance</div>
              <div style={styles.subRow}>2nd trance</div>
              <div style={styles.subRow}>3rd trance</div>
              <div style={styles.subRow}>Penalty and Late fee</div>
            </div>
            <div 
              style={{...styles.row, ...styles.expandableRow}} 
              onClick={toggleOutFlowExpansion}
            >
              <div style={styles.leftCell}>Cash Outflow from</div>
              <div style={{...styles.expandIcon,transform: isOutFlowExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                <div style={isOutFlowExpanded ? styles.arrowUp : styles.arrowDown}></div>
              </div>
            </div>
            
            <div style={{...styles.subRows,...styles.subCont, maxHeight: isOutFlowExpanded ? '360px' : '0',}}>
              <div style={styles.subRow}>Technology Expense</div>
              <div style={styles.subRow}>Third Party API or Outsourcing Costs</div>
              <div style={styles.subRow}>Administrative expenses</div>
              <div style={styles.subRow}>Employee salaries and benefits</div>
              <div style={styles.subRow}>Customer Acquisition Cost</div>
              <div style={styles.subRow}>Interest Paid for Borrowing</div>
              <div style={styles.subRow}>Regulatory and Compliance Costs</div>
              <div style={styles.subRow}>Provisioning and Write-offs</div>
            </div>
            
           
            <div style={styles.totalRow}>Net Cash Flow from Business</div>
          </div>

          {/* Scrollable Right Section */}
          <div style={styles.rightColumn}>
            <div style={styles.scrollableHeader}>
              {item.map((monthData, index) => (
                <div key={index} style={{...styles.headerCell, ...styles.monthHeader,width:`calc(100%/${item?.length})`}}>
                  {formatMonth(monthData.currentMonth)}
                </div>
              ))}
            </div>
            
            <div style={styles.scrollableContent}>
              {item.map((monthData, index) => (
                <div key={index} style={{...styles.monthColumn,width:`calc(100%/${item?.length})`}}>
                  <div style={{...styles.dataCell,...(monthData?.cashAtBeginning < 0 ? styles.dataCellNegative : {})}}>
                    {formatCurrency(monthData?.cashAtBeginning ?? "")}
                  </div>
                  
                  <div style={{...styles.dataCell, ...styles.dataCellThirdParty,...(monthData?.cashInflow < 0 ? styles.dataCellNegative : {})}}>
                    {formatCurrency(monthData?.cashInflow ?? "")}
                  </div>
                  {/* // cash inflow from drop */}
                  <div style={{...styles.subDataColumns,...styles.subCont,maxHeight: isExpanded ? '270px' : '0',}}>
                    <div style={{...styles.subDataCell, ...(monthData?.processingFees < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.processingFees ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.interest < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.interest ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.firstTranche < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData.firstTranche)}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.secondTranche < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.secondTranche ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdTranche < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.thirdTranche ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData?.penaltyLateFees < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.penaltyLateFees ?? "")}
                    </div>
                  
                  </div>

                  {/* // cash outflow from drop */}
                  <div style={{...styles.dataCell, ...styles.dataCellThirdParty,...(monthData?.cashOutflow < 0 ? styles.dataCellNegative : {})}}>
                    {formatCurrency(monthData?.cashOutflow ?? "")}
                  </div>
                  <div style={{...styles.subDataColumns,...styles.subCont,maxHeight: isOutFlowExpanded ? '360px' : '0',}}>
                    <div style={{...styles.subDataCell, ...(monthData.technologyExpense < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.technologyExpense ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.thirdPartApi < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.thirdPartApi ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.administrativeExpense < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.administrativeExpense ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.employeeSalary < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.employeeSalary ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.customerAcquisition < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.customerAcquisition ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.interestPaid < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.interestPaid ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.regulatoryCompliance < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.regulatoryCompliance ?? "")}
                    </div>
                    <div style={{...styles.subDataCell, ...(monthData.provisioning < 0 ? styles.dataCellNegative : {})}}>
                      {formatCurrency(monthData?.provisioning ?? "")}
                    </div>
                  
                  </div>
                  
                
                  <div style={{...styles.totalCell,background: 'linear-gradient(135deg,rgb(255, 255, 255) 0%,rgb(255, 255, 255) 100%)',borderTop: '0px solid #34d399',color:"#006580",...(monthData?.netCashflow < 0 ? styles.dataCellNegative : {})}}>
                    {formatCurrency(monthData?.netCashflow ?? "")}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashflowStatementTable;